<footer>
    <section class="copyright">
      &copy; 2020 Anouska de Graaf
    </section>
    <section class="socials">
      <a href="http://nl.linkedin.com/in/anouskadegraaf" alt="LinkedIn logo" target="_blank"><img src="../assets/icons/linkedin.svg" /></a>
      <a href="https://dribbble.com/anouskadg" alt="Dribbble logo" target="_blank"><img src="../assets/icons/dribbble.svg" /></a>
    </section>
</footer>